import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

class Background extends Component {
  ALLOWED_MODIFIERS = [
    'grey', 'white', 'darkGrey', 'lightGrey', 'bottomBorder',
    'green', 'yellow', 'fullHeight', 'veryDarkGrey', 'rounded'
  ]

  componentClassNames = () => {
    return bemClasses(
      'background',
      this.ALLOWED_MODIFIERS,
      this.props,
      this.props.className
    )
  }

  render = () => {
    return (
      <div className={this.componentClassNames()}>
        {this.props.children}
      </div>
    )
  }
}

export default Background
